import withStore, { TPresentable, TLoadingAwarePresenter } from "../withStore";
import Application from "../../Application";
import { IPaymentConfirmation } from "../../model/payment/PaymentConfirmation";
import PaymentConfirmationPresentationModel, {
  TPaymentConfirmationPresentationModel
} from "./model/PaymentConfirmationPresentationModel";

export interface TPaymentConfirmationPresenter extends TLoadingAwarePresenter {
  payment: TPaymentConfirmationPresentationModel;
  shareCode: string;
}

export interface IPaymentConfirmationPresenter
  extends TPaymentConfirmationPresenter,
    TPresentable {
  setPayment(payment: IPaymentConfirmation): void;
}

const defaultState: TPaymentConfirmationPresenter = {
  payment: {} as TPaymentConfirmationPresentationModel,
  shareCode: ""
};

const PaymentConfirmationPresenter = withStore<
  IPaymentConfirmationPresenter,
  TPaymentConfirmationPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): IPaymentConfirmationPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<
      TPaymentConfirmationPresenter & TLoadingAwarePresenter
    >();

    loader.start("paymentConfirmationLoader");

    const setPayment = (payment: IPaymentConfirmation) => {
      _store.update({
        payment: PaymentConfirmationPresentationModel(payment)
      });
      loader.stop("paymentConfirmationLoader");
    };

    return {
      ...state,

      store: _store,
      loader,
      application: _application,
      translate,
      setPayment
    };
  },
  defaultState
);

export default PaymentConfirmationPresenter;
